













































































import Vue from 'vue';
import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';
import MStoreForm from '@/components/shared/MStoreForm.vue';
import MStoreFormCheckbox from '@/components/shared/MStoreFormCheckbox.vue';
import MStoreFormInput from '@/components/shared/MStoreFormInput.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import {
  Configuration,
  ConfigurationChangeModel,
  StoreConstants,
  TaskServicesGlobalConfigurationModel,
  ValueType
} from '@/types';
import { TaskServicesService } from '@/services/TaskServicesService';
import { mapActions, mapGetters } from 'vuex';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';

export default Vue.extend({
  name: 'TaskServicesGlobalConfiguration',
  data() {
    return {
      isLoading: true,
      isSubmitting: false,
      taskServicesConfiguration: {} as TaskServicesGlobalConfigurationModel
    };
  },
  computed: {
    ...mapGetters(StoreConstants.ConfigurationChange.ModuleName, [
      StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLockedByCurrentSession,
      StoreConstants.ConfigurationChange.Getters.ConfigurationChange
    ]),
    isEditMode(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLockedByCurrentSession];
    },
    notificationEmailValidation(this: any) {
      return {
        valueType: ValueType.MultipleEmail,
        required: this.taskServicesConfiguration.notificationsEnabled
      };
    }
  },
  methods: {
    ...mapActions('applicationDirtyStore', ['setApplicationDirty']),
    ...mapActions(StoreConstants.ConfigurationChange.ModuleName, [
      StoreConstants.ConfigurationChange.Actions.GetChangeWithErrorPage
    ]),
    async getGlobalConfiguration() {
      this.taskServicesConfiguration = await TaskServicesService.getGlobalConfiguration();
    },
    async onSubmit(this: any) {
      const isValid = await this.$refs.globalConfigurationForm.$refs.ValidationObserver.validate();
      if (!isValid) {
        return;
      }

      const configurationChangeId = (this[
        StoreConstants.ConfigurationChange.Getters.ConfigurationChange
      ] as ConfigurationChangeModel).id;

      try {
        this.isSubmitting = true;
        await TaskServicesService.updateGlobalConfiguration({
          ...this.taskServicesConfiguration,
          configurationChangeId
        });
        SnotifyConfiguration.showSuccess('Configuration updated');
        this.setApplicationDirty(false);
        this.$router.push({ name: Configuration.TaskServices.TaskServices.name });
      } catch (error) {
        this.$log(error);
      } finally {
        this.isSubmitting = false;
      }
    },
    onCancel() {
      this.$router.push({ name: Configuration.TaskServices.TaskServices.name });
    }
  },
  async mounted(this: any) {
    await Promise.all([
      this.getGlobalConfiguration(),
      this[StoreConstants.ConfigurationChange.Actions.GetChangeWithErrorPage](this.CHANGE_CONTROLLER_PATH)
    ]);
    this.isLoading = false;
  },
  created(this: any) {
    this.CHANGE_CONTROLLER_PATH = 'taskServicesConfiguration';
  },
  components: {
    MStoreForm,
    MStoreSpinnerButton,
    MStoreFormCheckbox,
    MStoreFormInput,
    LoadingSpinner
  }
});
